
import { AfterViewInit, Component, ElementRef, Inject, Input, NgZone, PLATFORM_ID, TransferState } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  DxResizableComponent,
  DxResizableModule,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { ResizeEndEvent } from 'devextreme/ui/resizable';

/** @deprecated use AbcSplitterV2Component with abc-spl selector */
@Component({
  selector: 'abc-splitter',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./abc-splitter.component.scss'],
  imports: [DxResizableModule],
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost, DxResizableModule],
})
export class _AbcSplitterComponent extends DxResizableComponent implements AfterViewInit {
  @Input() orientation: string;
  @Input() removeTransforms: boolean = false; //this input it used when u want to remove transforms behavior of dx resizable to make the splitter just resized not moved
  /** @deprecated use nativeElement instead */
  public get elemRef(): HTMLElement {
    return this.nativeElement;
  }
  public readonly nativeElement: HTMLElement;
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, optionHost, transferState, platformId);
    this.nativeElement = elementRef.nativeElement;
  }

  override ngAfterViewInit() {
    const splitter = this.nativeElement;
    const parent = this.nativeElement.parentElement;

    if (this.orientation === 'horizontal') {
      splitter.classList.add('horizontalStyleIcon');
      parent.classList.add('horizontalBehaviour');
      this.handles = 'bottom';
    } else if (this.orientation === 'left') {
      splitter.classList.add('verticalLeftStyleIcon');
      parent.classList.add('verticalLeftBehaviour');
      this.handles = 'left';
    } else if (this.orientation === 'right') {
      splitter.classList.add('verticalRightStyleIcon');
      parent.classList.add('verticalRightBehaviour');
      this.handles = 'right';
    } else {
      splitter.classList.add('verticalRightStyleIcon');
      parent.classList.add('verticalRightBehaviour');
      this.handles = 'right';
    }
    this.instance.endUpdate();

    this.onResize.subscribe((e: ResizeEndEvent) => {
      if (splitter && this.removeTransforms) {
        splitter.style.transform = 'translate(0px, 0px)';
      }
    });
  }
}
